import strefy from "./strefy.json";
import type { MPZP__Zone, MPZP__ZoneOption } from "./types";

// Hand-curated from the pipeline's trojmiasto_mpzp_strefy_raw.json: the plans predate the ustawa and
// carry only free-text PRZEZNACZENIE, so `przeznaczenia` lists every raw string that maps onto a
// land-use group. That string is what the map style and the strefa filter key on.
const MPZP_ZONES: Array<MPZP__Zone> = strefy;

const MPZP_PRZEZNACZENIE_COLORS: Record<string, string> = Object.fromEntries(
	MPZP_ZONES.flatMap((zone) => zone.przeznaczenia.map((przeznaczenie): [string, string] => [przeznaczenie, zone.color])),
);

// Lifts a parcel's raw designations back onto the strefa the filter selects by.
const MPZP_STREFA_BY_PRZEZNACZENIE: Record<string, string> = Object.fromEntries(
	MPZP_ZONES.flatMap((zone) => zone.przeznaczenia.map((przeznaczenie): [string, string] => [przeznaczenie, zone.symbol])),
);

const MPZP_STREFA_OPTIONS: Array<MPZP__ZoneOption> = MPZP_ZONES.map((zone) => ({
	value: zone.symbol,
	label: zone.label,
}));

export { MPZP_PRZEZNACZENIE_COLORS, MPZP_STREFA_BY_PRZEZNACZENIE, MPZP_STREFA_OPTIONS, MPZP_ZONES };
